import axios from 'axios';
/* eslint-disable import/prefer-default-export */
import {
  GetReleasesListParams,
  IWhatsNewService,
  WhatsNewResponse
} from './contracts/whatsNew.service';

const token =
  'f535a25cc78b4fe8d1e3de13d0c422f77e4b950eca4e7a8e0fe34a51295da5833374616206186280c41891c4beaf2270775a3f1def6362bebab4eef8015b0eb9e796858fcd172cc195cb0dec91d17f45d0433d73054ccfe765dbb13708b74f10ab1f031e83120807b8843a8b70c13e5d327810aaa76fffd867c745f41acb0800';

const headers = {
  Authorization: `bearer ${token}`
};

export const WhatsNewService: IWhatsNewService = {
  async getReleasesList(
    params: GetReleasesListParams
  ): Promise<WhatsNewResponse> {
    const response = await axios.get(
      `https://strapi.pulsarito.com/api/updates?populate=*&locale=${params.locale}&sort[0]=publishedOn:desc`,
      {
        headers
      }
    );
    return response.data as WhatsNewResponse;
  }
};
